var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.servings > 1)?_c('span',{attrs:{"title":`Serves ${_vm.servings}`}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-account-multiple")]),_c('div',{staticClass:"servings"},[_vm._v(_vm._s(_vm.servings))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }